module.exports = __webpack_public_path__ + "static/media/flower10.e3951335.png";